export default {
  INDEX: "/",
  ERROR: '/error',
  RESULT: "/result",
};
